<template>
  <Formulario />
</template>

<script>
import Formulario from "@/pages/Processo/components/FormProcesso";

export default {
  components: {
    Formulario
  }
};
</script>
